<template>
  <div class="codeForm">
    <el-form  :model="ruleForm" ref="ruleForm" :rules="rules">
      <el-form-item prop="tel" style="margin-bottom:27px;">
        <el-input ref="telRef" v-model="ruleForm.tel" clearable placeholder="请输入手机号码" >
          <!-- <template slot="suffix">
            <i v-show="clearShow || ruleForm.tel" @mousedown.prevent="clearHandle"  class="el-icon-error" style="color:#333333;cursor:pointer;"></i>
          </template> -->
        </el-input>
      </el-form-item>
      <el-form-item prop="msgValidateCode" style="margin-bottom:27px;">
        <el-input v-model="ruleForm.msgValidateCode"  placeholder="请输入验证码"  >
          <template slot="suffix">
            <span class="code" @click="getMsgYzm">{{ btnMsgYzmVal }}</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 65px">
          <el-checkbox v-model="checked" label="1">阅读并同意<span class="note" @click.prevent="showAgreement">《风险告知》</span>和<span class="note" @click.prevent="showMark">《入市须知》</span></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('ruleForm')" :class="{'btn-active':checked&&ruleForm.tel&&ruleForm.msgValidateCode}">登录</el-button>
        <div class="serviceTel" v-if="APP_WINNY_NAME !== '景陶易购'">{{ APP_hotline }}</div>
      </el-form-item>
      <el-form-item class="RegisterTip">
        <span>还没有账号？</span>
        <a href="#" @click="toLogin">立即注册</a>
      </el-form-item>
      <cmsEntryAgreement ref="cmsEntryAgreement" @confirm="confirmAgree" />
    </el-form>
  </div>
  
</template>

<script>
import cmsEntryAgreement from '../../../components/base/entryAgreement/cmsEntryAgreement.vue';
export default {
   components:{
    cmsEntryAgreement
  },
  data(){
     const ValidateCode = (rule, value, callback) => {
      if (this.isPhoneError) {
        this.errorYzmMsg = ''
        this.isErrorYzmMsg = false
      }
      if (this.errorYzmMsg) {
        callback(new Error(this.errorYzmMsg))
        this.isErrorYzmMsg = true
        return
      }
      callback()
    }
   return{
      APP_hotline: window.g.APP_hotline,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      cmsEntryAgreement: null,
      telRef: null,
      clearShow: false,
      btnEnable: false,
      btnDisenable: false,
      isEnBtnGetYzm: false,
      btnMsgYzmVal: '获取验证码',
      errorYzmMsg: '',
      firstGetYzm: false,
      checked:false,
      ruleForm:{
        tel: '',
        passWord: '',
        msgValidateCode: '',
        tupian: ''
      },
      loginValue: {
        captchaCode: '', // 图形验证码
        captchaId: '', // 验证码序列号
        loginAccount: '', // 登录账号
        marketId: 28, // 市场id
        terminalType: 4, // 终端类型
        type: '1', // 登录方式 1 ：账号密码登录 2 短信验证码登录
        code: '', // 短信/邮箱验证码 false
        password: '', // 密码 false
        username: this.$route.query.username ? this.$route.query.username : ''
      },
      rules:{
         tel: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            min: 11,
            max: 11,
            message: '请输入11位手机号码',
            trigger: 'blur'
          }
        ],
         msgValidateCode: [
          { required: true, validator: ValidateCode },
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
      }
   }
  },
  methods: {
    confirmAgree() {
      this.checked = true
    },
    showAgreement() {
      console.log(this.$refs.cmsEntryAgreement);
      this.$refs.cmsEntryAgreement.showDia(592)
    },
    showMark() {
      this.$refs.cmsEntryAgreement.showDia(591)
    },
    clearHandle(){
      console.log(1111);
      this.$refs.telRef.focus()
      this.ruleForm.tel = null;
    },
    toLogin() {
      this.$emit("switchStatus", "register");
    },
    changLoginWay() {
      console.log(2222);
      this.$refs['ruleForm'].clearValidate()
    },
     setTime(e, vueThis) {
      const _this = this
      e--
      vueThis.btnMsgYzmVal = e + 's'
      if (e > 0) {
        setTimeout(function() {
          _this.setTime(e, vueThis)
        }, 1000)
      } else {
        vueThis.btnMsgYzmVal = '获取验证码'
        vueThis.btnDisenable = false
      }
    },
        // 获取手机验证码
    getMsgYzm() {
      if (this.ruleForm.tel === null || this.ruleForm.tel === undefined || this.ruleForm.tel === '') {
        this.$message('请输入手机号码')
        return
      }
      if (!util.isPoneAvailable(this.ruleForm.tel)) {
        this.$message('请输入11位手机号码')
        return
      }
      this.getPhoneRe()
      const sendValue = {
        id: 46,
        loginAccount: this.ruleForm.tel
      }
      this.$options.methods.setTime(60, this)
      this.btnDisenable = true
      BaseApi.sendCaptcha(sendValue).then(response => {
        if (Number(response.data.code) === 0) {
          this.$message(' 验证码已发送，请查看手机')
        } else {
          this.$message(response.data.message)
        }
      }).catch(error => {
        this.$message(error)
      })
    },
        // 查询手机号是否注册
    getPhoneRe() {
      protocol.param_getCellphoneExists.param.loginAccount = this.ruleForm.tel
      http.postFront(protocol.param_getCellphoneExists).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            if (this.btnDisenable) {
              return
            } else {
              const sendValue = {
                id: 46,
                loginAccount: this.ruleForm.tel
              }
              this.$options.methods.setTime(60, this)
              this.btnDisenable = true
              BaseApi.sendCaptcha(sendValue).then(response => {
                if (Number(response.data.code) === 0) {
                  this.firstGetYzm = true
                  this.errorYzmMsg = ''
                  this.$message(' 验证码已发送，请查看手机')
                } else {
                  this.$message(response.data.message)
                }
              }).cache(error => {
                this.$message(error)
              })
            }
          } else {
            this.$message('该手机号未注册')
          }
        } else {
          this.$message(message)
        }
      })
    },
    submitForm(formName){
      if (!this.checked) {
        this.$message('请阅读并同意《风险告知》和《入市须知》')
        return
      }
       this.$refs[formName].validate((valid) => {
        if (valid) {
          let loginProtol = BaseApi.codeLogin
          const self = this
          const tel = self.ruleForm.tel
          // 向后台发送用户登录名和密码
          this.loginValue.captchaCode = this.ruleForm.tupian // 图形验证码
          // captchaId
          this.loginValue.loginAccount = this.ruleForm.tel
          this.btnEnable = true
          this.loginValue.password = this.ruleForm.passWord
          this.loginValue.code = this.ruleForm.msgValidateCode
          loginProtol(this.loginValue).then(response => {
            const { code, message, value } = response.data
            if (code == 0) {
              // 清除历史账号访问交易页面商品缓存信息
              this.$store.commit('item', {})
              if (value && value.banTime) {
                this.$message(value.banTime)
                return
              }
              // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
              // if (self.checked == true) {
              //   self.setlocalStorage(self.ruleForm.tel, self.ruleForm.passWord)
              // } else {
              //   self.setlocalStorage('', '')
              // }
              const sessionInfo = {}
              sessionInfo.isLogin = true
              sessionInfo.userId = value.userId
              sessionInfo.sessionStr = value.sessionStr
              sessionInfo.firmCode = value.userCode
              sessionInfo.tel = tel
              sessionInfo.firmId = value.firmId
              sessionInfo.userType = value.type
              sessionInfo.userName = value.userName
              sessionInfo.lnvitationCode = value.lnvitationCode
              this.$store.commit('setSessionInfo', sessionInfo)
              // 为扫码跳移动端做准备
              const urlQr = `cellPhone=${tel}&lnvitationCode=${value.lnvitationCode}&sessionStr=${value.sessionStr}&type=${value.type}&userCode=${value.userCode}&userId=${value.userId}&userName=${value.userName}`
              localStorage.setItem('qrContent', urlQr)
              localStorage.setItem('myPhone', tel)
              const sessionStr = response.data.value.sessionStr
              const sessionUserId = response.data.value.userId
              const sessionFirmId = response.data.value.firmId
              const sessionFirmCode = response.data.value.userCode
              const sessionTel = tel
              const lnvitationCode = value.lnvitationCode
              const sessionUserType = response.data.value.type
              const userName = response.data.value.userName
              // 将session信息存到localstorage中
              sessionStorage.sessionStr = sessionStr
              sessionStorage.sessionUserId = sessionUserId
              sessionStorage.sessionFirmCode = sessionFirmCode
              sessionStorage.sessionTel = sessionTel
              sessionStorage.userType = sessionUserType
              localStorage.setItem('lnvitationCode_w', lnvitationCode)
              localStorage.setItem('userName', userName)
              // 修改请求参数的登录信息
              for (const item in protocol) {
                if (protocol[item].param) {
                  if ('sessionStr' in protocol[item].param) {
                    protocol[item].param.sessionStr = sessionStr
                    protocol[item].param.userId = sessionUserId
                  }
                }
              }
              for (const key in protocol) {
                if (protocol[key].param) {
                  if ('firmId' in protocol[key].param) {
                    protocol[key].param.firmId = sessionFirmId
                  }
                  if ('ffirmId' in protocol[key].param) {
                    protocol[key].param.ffirmId = sessionFirmId
                  }
                  if ('firmCode' in protocol[key].param) {
                    protocol[key].param.firmCode = sessionFirmCode
                  }
                  if ('tel' in protocol[key].param) {
                    protocol[key].param.tel = sessionTel
                  }
                }
                if (protocol[key].data) {
                  if ('firmIds' in protocol[key].data) {
                    protocol[key].data.firmIds = sessionFirmId
                  }
                  if ('firmId' in protocol[key].data) {
                    protocol[key].data.firmId = sessionFirmId
                  }
                }
              }
              // this.userRiskTimePastDue()
              this.queryCommodityStrategy()
              // this.getMoneyPwdFlgByFirmId()
              // this.sendMsgLoginInformation()
              // this.btnEnable = false
            } else {
              // this.VerificationCode()
              this.$message(message)
              this.btnEnable = false
            }
          }).catch(() => {
            this.btnEnable = false
          })
          setTimeout(()=>{
            this.ruleForm.msgValidateCode = null
          },3000)
        }
      })
    },
        // 商品策略查询
    queryCommodityStrategy() {
      const _this = this
      http.postFront(protocol.param_queryCommodityStrategy).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.$store.commit('setQueryTradeAuthArr', value)
          this.$store.commit('setCommodityStrategy', value)
          hqWs.send(hqProtocol.param_SYMBOLS)
          hqWs.send(hqProtocol.param_businessJb)
          if (value.length > 0) {
            this.$router.push('/quotationList')
          } else {
            this.$message('暂未关联商品')
            // this.$router.push('/quotationListNosession')
          }
        } else {
          this.$message(message)
          // this.$router.push('/quotationList')
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
        }
      }).catch((e) => {
        setTimeout(() => {
          _this.queryCommodityStrategy()
        }, 1000)
      })
    },
        // 登录后发送短信验证码
    // sendMsgLoginInformation() {
    //   protocol.param_sendMsgLoginInformation.param.params = [
    //     util.dateFormateC(new Date()), 'pc端'
    //   ]
    //   http.postFront(protocol.param_sendMsgLoginInformation).then(response => {
    //   })
    // },
  },
};
</script>

<style lang="scss" scoped>
.codeForm {
  .serviceTel{
    margin-top: 20px;
    color: #999999;
  }
  /deep/ .el-form-item__content{
    line-height: 14px;
  }
  /deep/ .el-checkbox__label{
    font-family: Source Han Sans SC !important;
    font-weight: 200 !important;
    font-size: 12px !important;
    color: #999999 !important;
  } 
  /deep/ .el-input__suffix {
    display: flex;
    align-items: center;
    margin-right: 14px;
    .code{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      cursor: pointer;
      border: none;
      background: transparent;
    }
  }
  .RegisterTip a{
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 39px;
  }
  .note{
    font-weight: 600;
    color: #333333;
  }
}
</style>